import { useMutation, MutationConfigType, UseMutationResult } from "~/libs";

import { ApiClient } from "~/utils";

import { ApiKpiDailyPerformanceMutate } from "~/domains";

type RequestDataType = {
  kpiObjectiveId: string;
  id: string;
  body: {
    performanceDate: string;
    performance: number;
    kpiDailyPerformanceClientCompanies: {
      name: string;
      price?: number | "";
    }[];
  };
};

const request = ({ kpiObjectiveId, id, body }: RequestDataType) => {
  return new ApiClient()
    .put<ApiKpiDailyPerformanceMutate>(
      `/api/members/kpi/kpi_objectives/${kpiObjectiveId}/kpi_daily_performances/${id}`,
      {
        kpiDailyPerformance: body,
      },
    )
    .then((res) => {
      return res.data;
    });
};

type PropsType = {
  options?: MutationConfigType<typeof request>;
};

export const useApisMembersKpiKpiObjectivesKpiDailyPerformancesUpdate = ({
  options = {},
}: PropsType = {}): UseMutationResult<
  ApiKpiDailyPerformanceMutate,
  RequestDataType
> => {
  return useMutation(request, { ...options });
};
